import apiClient from "./apiClient";

interface StatsFilters {
  outletId?: string;
  dateFrom?: string;
  dateTo?: string;
}

class StatsService {
  async getDashboard(companyId: string, filters: StatsFilters = {}) {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value.toString());
      }
    });

    const url = `/api/companies/${companyId}/stats/dashboard?${params.toString()}`;
    const response = await apiClient.get(url);
    return response;
  }
}

export default new StatsService();
